import { Footer as NewFooter } from "@ajbellbusinessolution/fe-components";
import { DrupalLink } from 'src/Utils';

export function FooterRebranded({ footerNavigation }) {
    return <>
        <section className="highlight darkblue-500-bg white-text region-footer-highlighted no-print">
            <p className="max-characters-none">
                The value of your investments can go down as well as up and you may get back less than you originally invested.
                We don&#39;t offer advice, so it&#39;s important you understand the <DrupalLink action={`/risks`}>risks</DrupalLink>, if you&#39;re unsure please
                consult a suitably qualified financial adviser. Tax treatment depends on your individual circumstances and rules
                may change. Past performance is not a guide to future performance and some investments need to be held for the
                long term.
            </p>
        </section>
        <NewFooter footerData={footerNavigation} />
    </>
}